import { IInspectionFlowGroup } from '@shared/services';
import {
  FlowStatus,
  InspectionFlowType,
  QuestionnairePlacement,
  QuestionnaireType,
} from '@shared/services/inspectionService/inspectionFlows/types/enums';
import { TypeMask } from '@shared/services/inspectionService/masks/types/enums';

export const WHEELS_FLOWS_TEMPLATES = [
  {
    flowConfig: [
      {
        order: 0,
        executionTime: 20,
        type: TypeMask.EXTERIOR_VIN_STICKER,
      },
      {
        order: 1,
        executionTime: 20,
        type: TypeMask.INTERIOR_ODOMETER_MILES,
      },
      {
        order: 2,
        executionTime: 20,
        type: TypeMask.EXTERIOR_TIRE_LABEL,
      },

      // Wheels + tread (4 tires)
      {
        order: 3,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_WHEEL,
      },
      {
        order: 4,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_TIRE_TREAD,
      },
      {
        order: 5,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_WHEEL,
      },
      {
        order: 6,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_TIRE_TREAD,
      },
      {
        order: 7,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_WHEEL,
      },
      {
        order: 8,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_TIRE_TREAD,
      },
      {
        order: 9,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_WHEEL,
      },
      {
        order: 10,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_TIRE_TREAD,
      },
    ],
    title: 'Tire Flow',
    description: 'Tire product inspection flow (disabled by default)',
    status: FlowStatus.INACTIVE,
    intro: {
      checkList: [
        {
          order: 0,
          title: 'Outdoor & day time',
        },
        {
          order: 1,
          title: 'Park in a safe and well lit area',
        },
        {
          order: 2,
          title: 'Make sure all 4 tires are visible and accessible',
        },
      ],
      processExplainer: true,
      questionnaire: [],
    },
    flowType: InspectionFlowType.TIRE,
    questionnairePlacement: QuestionnairePlacement.BEGINNING,
    allowGalleryUploads: true,
    allowDamageReporting: false,
    additionalSettings: {
      vertical: true,
      horizontal: true,
      signature: false,
      useTermsAndConditions: true,
      redirectUrl: 'https://www.selfinspection.com',
    },
  },
];

export const WHEELS_FLOWS_TEMPLATES_V2 = [
  {
    flowConfig: [
      {
        order: 1,
        executionTime: 20,
        type: TypeMask.EXTERIOR_VIN_STICKER,
      },
      {
        order: 2,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_TIRE_TREAD,
      },
      {
        order: 3,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_TIRE_TREAD,
      },
      {
        order: 4,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_TIRE_TREAD,
      },
      {
        order: 5,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_TIRE_TREAD,
      },
    ],
    title: 'Tire Flow',
    description: 'Tire product inspection flow (disabled by default)',
    status: FlowStatus.INACTIVE,
    intro: {
      checkList: [
        {
          order: 0,
          title: 'Outdoor & day time',
        },
        {
          order: 1,
          title: 'Park in a safe and well lit area',
        },
        {
          order: 2,
          title: 'Make sure all 4 tires are visible and accessible',
        },
      ],
      processExplainer: true,
      questionnaire: [],
    },
    flowType: InspectionFlowType.TIRE,
    questionnairePlacement: QuestionnairePlacement.BEGINNING,
    allowGalleryUploads: true,
    allowDamageReporting: false,
    additionalSettings: {
      vertical: true,
      horizontal: true,
      signature: false,
      useTermsAndConditions: false,
      redirectUrl: 'https://www.selfinspection.com',
    },
  },
];

export const INSPECTION_FLOWS_TEMPLATES = [
  {
    flowConfig: [
      {
        order: 0,
        executionTime: 20,
        type: TypeMask.EXTERIOR_VIN_STICKER,
      },
      {
        order: 1,
        executionTime: 20,
        type: TypeMask.INTERIOR_FRONT_SEATS_LEFT_SIDE,
      },
      {
        order: 2,
        executionTime: 20,
        type: TypeMask.INTERIOR_ODOMETER_MILES,
      },
      {
        order: 3,
        executionTime: 20,
        type: TypeMask.INTERIOR_WINDSHIELD_FROM_INSIDE,
      },
      {
        order: 4,
        executionTime: 20,
        type: TypeMask.INTERIOR_LEFT_FRONT_DOOR_TRIM,
      },
      {
        order: 5,
        executionTime: 60,
        type: TypeMask.EXTERIOR_360_VIDEO,
      },
    ],
    title: 'Basic Visual Flow',
    description: 'Self Inspection flow',
    status: FlowStatus.ACTIVE,
    intro: {
      checkList: [
        {
          order: 0,
          title: 'Clean and empty your vehicle',
        },
        {
          order: 1,
          title: 'Outdoor & day time',
        },
        {
          order: 2,
          title: 'Park in a safe and well lit area',
        },
        {
          order: 3,
          title: 'Ample space around the car',
        },
        {
          order: 4,
          title: 'Turn off Bluetooth',
        },
      ],
      processExplainer: true,
      questionnaire: [
        {
          order: 0,
          title: 'Does your car have any mechanical issues?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 1,
          title: 'Was your car prior rental?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 2,
          title: 'Any oil leaks?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 3,
          title: 'Do all the power windows work?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 4,
          title: 'Does the parking brake work properly?',
          type: QuestionnaireType.OPEN_ENDED,
        },
      ],
    },
    questionnairePlacement: QuestionnairePlacement.BEGINNING,
    allowGalleryUploads: true,
    allowDamageReporting: true,
    additionalSettings: {
      vertical: true,
      horizontal: true,
      signature: false,
      useTermsAndConditions: true,
      redirectUrl: 'https://www.selfinspection.com',
    },
  },
  {
    flowConfig: [
      {
        order: 0,
        executionTime: 20,
        type: TypeMask.EXTERIOR_VIN_STICKER,
      },
      {
        order: 1,
        executionTime: 20,
        type: TypeMask.EXTERIOR_TIRE_LABEL,
      },
      {
        order: 2,
        executionTime: 20,
        type: TypeMask.INTERIOR_FRONT_SEATS_LEFT_SIDE,
      },
      {
        order: 3,
        executionTime: 20,
        type: TypeMask.INTERIOR_DASH_PANEL,
      },
      {
        order: 4,
        executionTime: 20,
        type: TypeMask.INTERIOR_ODOMETER_MILES,
      },
      {
        order: 5,
        executionTime: 20,
        type: TypeMask.INTERIOR_LEFT_FRONT_DOOR_TRIM,
      },
      {
        order: 6,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_WHEEL,
      },
      {
        order: 7,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_TIRE_TREAD_ANGLE,
      },
      {
        order: 8,
        executionTime: 20,
        type: TypeMask.EXTERIOR_REAR_BUMPER,
      },
      {
        order: 9,
        executionTime: 20,
        type: TypeMask.EXTERIOR_ROOF_RIGHT_REAR_CORNER,
      },
      {
        order: 10,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_TIRE_TREAD_ANGLE,
      },
      {
        order: 11,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_WHEEL,
      },
      {
        order: 12,
        executionTime: 20,
        type: TypeMask.INTERIOR_REAR_SEATS_RIGHT_SIDE,
      },
      {
        order: 13,
        executionTime: 20,
        type: TypeMask.INTERIOR_RIGHT_REAR_DOOR_TRIM,
      },
      {
        order: 14,
        executionTime: 20,
        type: TypeMask.EXTERIOR_RIGHT_SIDE_WINDSHIELD,
      },
      {
        order: 15,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_WHEEL,
      },
      {
        order: 16,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_TIRE_TREAD_ANGLE,
      },
      {
        order: 17,
        executionTime: 20,
        type: TypeMask.EXTERIOR_FRONT_BUMPER,
      },
      {
        order: 18,
        executionTime: 20,
        type: TypeMask.EXTERIOR_HOOD_WINDSHIELD,
      },
      {
        order: 19,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_TIRE_TREAD_ANGLE,
      },
      {
        order: 20,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_WHEEL,
      },
      {
        order: 21,
        executionTime: 60,
        type: TypeMask.EXTERIOR_360_VIDEO,
      },
    ],
    title: 'Standard Visual Flow',
    description: 'Self Inspection flow',
    status: FlowStatus.ACTIVE,
    intro: {
      checkList: [
        {
          order: 0,
          title: 'Clean and empty your vehicle',
        },
        {
          order: 1,
          title: 'Outdoor & day time',
        },
        {
          order: 2,
          title: 'Park in a safe and well lit area',
        },
        {
          order: 3,
          title: 'Ample space around the car',
        },
        {
          order: 4,
          title: 'Turn off Bluetooth',
        },
      ],
      processExplainer: true,
      questionnaire: [
        {
          order: 0,
          title: 'Does your car have any mechanical issues?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 1,
          title: 'Was your car prior rental?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 2,
          title: 'Any oil leaks?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 3,
          title: 'Do all the power windows work?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 4,
          title: 'Does the parking brake work properly?',
          type: QuestionnaireType.OPEN_ENDED,
        },
      ],
    },
    questionnairePlacement: QuestionnairePlacement.BEGINNING,
    allowGalleryUploads: true,
    allowDamageReporting: true,
    additionalSettings: {
      vertical: true,
      horizontal: true,
      signature: false,
      useTermsAndConditions: true,
      redirectUrl: 'https://www.selfinspection.com',
    },
  },
  {
    flowConfig: [
      {
        order: 0,
        executionTime: 20,
        type: TypeMask.EXTERIOR_VIN_STICKER,
      },
      {
        order: 1,
        executionTime: 20,
        type: TypeMask.EXTERIOR_TIRE_LABEL,
      },
      {
        order: 2,
        executionTime: 20,
        type: TypeMask.INTERIOR_FRONT_SEATS_LEFT_SIDE,
      },
      {
        order: 3,
        executionTime: 20,
        type: TypeMask.INTERIOR_DASH_PANEL,
      },
      {
        order: 4,
        executionTime: 20,
        type: TypeMask.INTERIOR_WINDSHIELD_FROM_INSIDE,
      },
      {
        order: 5,
        executionTime: 20,
        type: TypeMask.INTERIOR_ODOMETER_MILES,
      },
      {
        order: 6,
        executionTime: 20,
        type: TypeMask.INTERIOR_LEFT_FRONT_DOOR_TRIM,
      },
      {
        order: 7,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_WHEEL,
      },
      {
        order: 8,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_REAR_TIRE_TREAD_ANGLE,
      },
      {
        order: 9,
        executionTime: 20,
        type: TypeMask.EXTERIOR_LEFT_REAR_CORNER,
      },
      {
        order: 10,
        executionTime: 20,
        type: TypeMask.INTERIOR_TRUNK,
      },
      {
        order: 11,
        executionTime: 20,
        type: TypeMask.INTERIOR_SPARE_TIRE,
      },
      {
        order: 12,
        executionTime: 20,
        type: TypeMask.EXTERIOR_REAR_BUMPER,
      },
      {
        order: 13,
        executionTime: 20,
        type: TypeMask.EXTERIOR_RIGHT_REAR_CORNER,
      },
      {
        order: 14,
        executionTime: 20,
        type: TypeMask.EXTERIOR_ROOF_RIGHT_REAR_CORNER,
      },
      {
        order: 15,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_TIRE_TREAD_ANGLE,
      },
      {
        order: 16,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_REAR_WHEEL,
      },
      {
        order: 17,
        executionTime: 20,
        type: TypeMask.INTERIOR_REAR_SEATS_RIGHT_SIDE,
      },
      {
        order: 18,
        executionTime: 20,
        type: TypeMask.INTERIOR_RIGHT_REAR_DOOR_TRIM,
      },
      {
        order: 19,
        executionTime: 20,
        type: TypeMask.INTERIOR_RIGHT_REAR_HEADLINER,
      },
      {
        order: 20,
        executionTime: 20,
        type: TypeMask.INTERIOR_DASHBOARD,
      },
      {
        order: 21,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_WHEEL,
      },
      {
        order: 22,
        executionTime: 20,
        type: TypeMask.WHEEL_RIGHT_FRONT_TIRE_TREAD_ANGLE,
      },
      {
        order: 23,
        executionTime: 20,
        type: TypeMask.EXTERIOR_RIGHT_SIDE_WINDSHIELD,
      },
      {
        order: 24,
        executionTime: 20,
        type: TypeMask.EXTERIOR_RIGHT_FRONT_CORNER,
      },
      {
        order: 25,
        executionTime: 20,
        type: TypeMask.EXTERIOR_FRONT_BUMPER,
      },
      {
        order: 26,
        executionTime: 20,
        type: TypeMask.EXTERIOR_HOOD_WINDSHIELD,
      },
      {
        order: 27,
        executionTime: 20,
        type: TypeMask.EXTERIOR_LEFT_FRONT_CORNER,
      },
      {
        order: 28,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_TIRE_TREAD_ANGLE,
      },
      {
        order: 29,
        executionTime: 20,
        type: TypeMask.WHEEL_LEFT_FRONT_WHEEL,
      },
      {
        order: 30,
        executionTime: 20,
        type: TypeMask.EXTERIOR_ROOF_LEFT_FRONT_CORNER,
      },
      {
        order: 31,
        executionTime: 20,
        type: TypeMask.EXTERIOR_LEFT_SIDE_WINDSHIELD,
      },
      {
        order: 32,
        executionTime: 60,
        type: TypeMask.EXTERIOR_360_VIDEO,
      },
    ],
    title: 'Complete Visual Flow',
    description: 'Self Inspection flow',
    status: FlowStatus.ACTIVE,
    intro: {
      checkList: [
        {
          order: 0,
          title: 'Clean and empty your vehicle',
        },
        {
          order: 1,
          title: 'Outdoor & day time',
        },
        {
          order: 2,
          title: 'Park in a safe and well lit area',
        },
        {
          order: 3,
          title: 'Ample space around the car',
        },
        {
          order: 4,
          title: 'Turn off Bluetooth',
        },
      ],
      processExplainer: true,
      questionnaire: [
        {
          order: 0,
          title: 'Does your car have any mechanical issues?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 1,
          title: 'Was your car prior rental?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 2,
          title: 'Any oil leaks?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 3,
          title: 'Do all the power windows work?',
          type: QuestionnaireType.OPEN_ENDED,
        },
        {
          order: 4,
          title: 'Does the parking brake work properly?',
          type: QuestionnaireType.OPEN_ENDED,
        },
      ],
    },
    questionnairePlacement: QuestionnairePlacement.BEGINNING,
    allowGalleryUploads: true,
    allowDamageReporting: true,
    additionalSettings: {
      vertical: true,
      horizontal: true,
      signature: false,
      useTermsAndConditions: true,
      redirectUrl: 'https://www.selfinspection.com',
    },
  },
  ...WHEELS_FLOWS_TEMPLATES, //  ...WHEELS_FLOWS_TEMPLATES_V2,
];

export const rentalFlowConfig = [
  {
    order: 0,
    executionTime: 20,
    type: TypeMask.EXTERIOR_VIN_STICKER,
  },
  {
    order: 1,
    executionTime: 20,
    type: TypeMask.INTERIOR_KEYS_FOBS,
  },
  {
    order: 2,
    executionTime: 20,
    type: TypeMask.INTERIOR_ODOMETER_MILES,
  },
  {
    order: 3,
    executionTime: 20,
    type: TypeMask.INTERIOR_FUEL_LEVEL,
  },
  {
    order: 4,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_FRONT_CORNER,
  },
  {
    order: 5,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_REAR_CORNER,
  },
  {
    order: 6,
    executionTime: 20,
    type: TypeMask.EXTERIOR_REAR_BUMPER,
  },
  {
    order: 7,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_REAR_CORNER,
  },
  {
    order: 8,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_FRONT_CORNER,
  },
  {
    order: 9,
    executionTime: 20,
    type: TypeMask.EXTERIOR_FRONT_BUMPER,
  },
  {
    order: 10,
    executionTime: 20,
    type: TypeMask.EXTERIOR_HOOD_WINDSHIELD,
  },
  {
    order: 11,
    executionTime: 60,
    type: TypeMask.EXTERIOR_360_VIDEO,
  },
];

export const BEFORE_AFTER_FLOW_CONFIG = [
  {
    order: 0,
    executionTime: 20,
    type: TypeMask.EXTERIOR_VIN_STICKER,
  },
  {
    order: 1,
    executionTime: 20,
    type: TypeMask.INTERIOR_ODOMETER_MILES,
  },
  {
    order: 2,
    executionTime: 20,
    type: TypeMask.INTERIOR_FUEL_LEVEL,
  },
  {
    order: 3,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_FRONT_CORNER,
  },
  {
    order: 4,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_FULL_SIDE,
  },
  {
    order: 5,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_REAR_CORNER,
  },
  {
    order: 6,
    executionTime: 20,
    type: TypeMask.EXTERIOR_REAR_BUMPER,
  },
  {
    order: 7,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_REAR_CORNER,
  },
  {
    order: 8,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_FULL_SIDE,
  },
  {
    order: 9,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_FRONT_CORNER,
  },
  {
    order: 10,
    executionTime: 20,
    type: TypeMask.EXTERIOR_FRONT_BUMPER,
  },
  {
    order: 11,
    executionTime: 20,
    type: TypeMask.EXTERIOR_HOOD_WINDSHIELD,
  },
];

// Optimal AI Inspection — canonical required capture set for InspectionFlowType.EXPEDITED_AI.
// These 16 step types are non-removable from a flow of this type (enforced in inspection-service's
// InspectionFlowsService.validateOptimalAiFlowConfig). Operators may reorder them and may add extra
// optional steps, but may not delete any of these. AI processing is out of scope.
export const EXPEDITED_AI_FLOW_CONFIG = [
  {
    order: 0,
    executionTime: 20,
    type: TypeMask.EXTERIOR_VIN_STICKER,
  },
  {
    order: 1,
    executionTime: 20,
    type: TypeMask.EXTERIOR_TIRE_LABEL,
  },
  {
    order: 2,
    executionTime: 20,
    type: TypeMask.INTERIOR_ODOMETER_MILES,
  },
  {
    order: 3,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_FRONT_CORNER,
  },
  {
    order: 4,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_SIDE_WINDSHIELD,
  },
  {
    order: 5,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_FRONT_HALF,
  },
  {
    order: 6,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_REAR_HALF,
  },
  {
    order: 7,
    executionTime: 20,
    type: TypeMask.EXTERIOR_LEFT_REAR_CORNER,
  },
  {
    order: 8,
    executionTime: 20,
    type: TypeMask.EXTERIOR_REAR_BUMPER,
  },
  {
    order: 9,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_REAR_CORNER,
  },
  {
    order: 10,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_FRONT_HALF,
  },
  {
    order: 11,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_REAR_HALF,
  },
  {
    order: 12,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_FRONT_CORNER,
  },
  {
    order: 13,
    executionTime: 20,
    type: TypeMask.EXTERIOR_FRONT_BUMPER,
  },
  {
    order: 14,
    executionTime: 20,
    type: TypeMask.EXTERIOR_HOOD_WINDSHIELD,
  },
  {
    order: 15,
    executionTime: 20,
    type: TypeMask.EXTERIOR_RIGHT_SIDE_WINDSHIELD,
  },
];

export const INSPECTION_PICKUP_FLOW_TEMPLATE = {
  flowConfig: [...rentalFlowConfig],
  title: 'Pickup Inspection Flow',
  description: 'Vehicle pickup inspection by a customer',
  status: FlowStatus.ACTIVE,
  intro: {
    checkList: [],
    processExplainer: true,
    questionnaire: [],
  },
  questionnairePlacement: QuestionnairePlacement.BEGINNING,
  allowGalleryUploads: true,
  allowDamageReporting: true,
  additionalSettings: {
    vertical: true,
    horizontal: true,
    signature: false,
    useTermsAndConditions: true,
    redirectUrl: 'https://www.selfinspection.com',
  },
};

export const INSPECTION_DROPOFF_FLOW_TEMPLATE = {
  flowConfig: [...rentalFlowConfig],
  title: 'Drop Off Inspection Flow',
  description: 'Vehicle return inspection by a customer',
  status: FlowStatus.ACTIVE,
  intro: {
    checkList: [],
    processExplainer: true,
    questionnaire: [],
  },
  questionnairePlacement: QuestionnairePlacement.BEGINNING,
  allowGalleryUploads: true,
  allowDamageReporting: true,
  additionalSettings: {
    vertical: true,
    horizontal: true,
    signature: false,
    useTermsAndConditions: true,
    redirectUrl: 'https://www.selfinspection.com',
  },
};

export const INSPECTION_EMPLOYEE_FLOW_TEMPLATE = {
  flowConfig: [...rentalFlowConfig],
  title: 'Employee Inspection Flow',
  description: 'In-house inspection by a staff member',
  status: FlowStatus.ACTIVE,
  intro: {
    checkList: [],
    processExplainer: true,
    questionnaire: [],
  },
  questionnairePlacement: QuestionnairePlacement.BEGINNING,
  allowGalleryUploads: true,
  allowDamageReporting: true,
  additionalSettings: {
    vertical: true,
    horizontal: true,
    signature: false,
    useTermsAndConditions: true,
    redirectUrl: 'https://www.selfinspection.com',
  },
};

export const INSPECTION_FLOW_GROUP_TEMPLATES: IInspectionFlowGroup[] = [
  {
    title: 'Standard Rental Inspection',
    description: 'Full cycle for rentals: vehicle pickup, return and in-house inspection by a staff member.',
    status: FlowStatus.ACTIVE,
    flows: ['pickup', 'dropOff', 'employee'],
    flowType: InspectionFlowType.VISUAL,
  },
  {
    title: 'Rental Group - Basic',
    description: 'Default flow group for rental companies',
    status: FlowStatus.ACTIVE,
    flows: ['pickup', 'dropOff'],
    flowType: InspectionFlowType.VISUAL,
  },
  {
    title: 'Internal Employee Inspection',
    description: 'Purely a service inspection with no customer input.',
    status: FlowStatus.ACTIVE,
    flows: ['employee'],
    flowType: InspectionFlowType.VISUAL,
  },
];
